export default __webpack_public_path__ + "static/media/photo_5282747746622312928_y.fd38f35c.jpg";